(ns rothko.button.component
  (:require [reagent.ratom :as ratom]
            [rothko.component.core :refer [defcomp]]
            [rothko.icon.component :as icon]
            [rothko.icon-animated.component :refer [spinner]]))

(defcomp button
  {:component-type ::button}
  [{:keys [aria-label class disabled? id loading? on-click style tab-index theme type appearance]
    :or {type :button}
    :as props} & children]
  (into [:button.rothko-btn
         {:aria-label aria-label
          :class (concat appearance class)
          :disabled (or disabled? loading?)
          :tab-index tab-index
          :id id
          :on-click on-click
          :style style
          :type type}]
        (cond-> children
          loading? (conj [spinner {:size 20}]))))

(defn drop-up-content
  [menu-buttons appearance on-click expanded?]
  [:div {:class (cond-> [:btn-drop-content]
                  expanded? (conj :expanded))}
   (into
    [:ul]
    (for [{:keys [text] :as props} menu-buttons]
      ^{:key props}
      [:div.item
       [:li [button (assoc props
                           :appearance appearance
                           :on-click #(on-click props))
             text]]]))])

(defcomp drop-up-button
  [props & children]
  (let [expanded? (ratom/atom false)]
    (fn [{:keys [appearance class disabled? menu-buttons on-click] :as props} & children]
      (let [appearance (conj appearance :no-outline)]
        [:div.drop-up {:class class}
         [:div.button-container
          [button {:appearance appearance
                   :on-click #(swap! expanded? not)
                   :disabled? disabled?}
           [:span.button-text children]
           [icon/icon {:icon (if @expanded? :angle-up :angle-down)
                       :size 20
                       :class [:drop-up-icon]}]]]
         [drop-up-content menu-buttons appearance on-click @expanded?]]))))

(defn separator
  []
  [:div.button-separator
   {:style {:display :flex
            :color :grey
            :align-items :center
            :justify-content :center
            :border-right "2px solid #aaa"
            :margin "0 1rem"
            :width "1px"}}])
